export default function Count({ isLoading, count }: any) {
  return (
    <div className="rounded-sm text-black text-3xl font-bold">
      {isLoading ? (
        <div className="w-16 bg-gray-100 h-7 mt-2 rounded-md"></div>
      ) : (
        count
      )}
    </div>
  );
}
